<template>
  <div>
    <v-dialog
      fullscreen 
      hide-overlay 
      transition="slide-full-modal-transition" 
      v-model="formOpened" content-class="j_modal" persistent>
      <v-card>
        <div class="modal__header full_title pd_left_3">
          <button class="hamberger_menu" type="button"  @click="onAction('cancel')">
            <v-icon>mdi-menu</v-icon>
          </button>
          <span>Format Pie Chart <span class="sub_title">{{ `${idxNum} ${subTitle}` }}</span></span>
        </div>

        <v-card-text class="modal__formControl properties8 type3 dark_theme">
          <!-- <v-form v-model="valid" ref="form"> -->
            <v-container>
              <v-card-actions class="modal_toolbar">
                <div class="tool_menus">
                  <div>
                    <div
                      data-pie-quickbtn="normal"
                      title="normal"
                      :class="chartItem.ChartType == __C_.TYPE_CODE_NORMAL ? 'selected': ''"
                      @click="onChartType(__C_.TYPE_CODE_NORMAL)">
                    </div>
                  </div>
                  <div>
                    <div
                      data-pie-quickbtn="donut"
                      title="donut"
                      :class="chartItem.ChartType == __C_.TYPE_CODE_DONUT ? 'selected': ''"
                      @click="onChartType(__C_.TYPE_CODE_DONUT)">
                    </div>
                  </div>
                  <div>
                    <div
                      data-pie-quickbtn="stepped"
                      title="stepped"
                      :class="chartItem.ChartType == __C_.TYPE_CODE_STEPPED ? 'selected': ''"
                      @click="onChartType(__C_.TYPE_CODE_STEPPED)">
                    </div>
                  </div>
                </div>
              </v-card-actions>
              <div class="modal_dark_btn">
                <j-button
                  class="type01 sky  type_full"
                  :class="{ disabled: !resetable }"
                  :disabled="!resetable"
                  @click="onAction('save')"
                  >Save
                </j-button>
                <j-button
                  class="type01 sky  type_full"
                  :class="{ disabled: !resetable }"
                  :disabled="!resetable"
                  @click="onAction('saveas')"
                  >SaveAs
                </j-button>
                <j-button v-if="modeMod" 
                  class="type01 delete  type_full" 
                  @click="onAction('delete')"
                  >Delete
                </j-button>
                <div class="check_wrapper">
                  <v-checkbox v-model="update" :label="'Update'"/>
                  <v-checkbox :label="'Page Svg'" />
                  <v-checkbox :label="'Fixed'" />
                </div>
                <button class="help" @click="(e) => { helper=!helper }"></button>
              </div>
              <div class="modal__formControl_inside">
                <v-tabs v-model="stepper" class="wrap__modal_wfix">
                  <v-tab data-type="navigation" title="navigation"></v-tab>
                  <v-tab data-type="database" title="database"></v-tab>
                  <v-tab data-type="canvas" title="canvas"></v-tab>
                  <v-tab data-type="circle" title="circle"></v-tab>
                  <v-tab data-type="title" title="title"></v-tab>
                  <v-tab data-type="legend" title="legend"></v-tab>
                  <v-tab data-type="guideline" title="guideline"></v-tab>
                  <v-tab data-type="note" title="note"></v-tab>

                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-navigation ref="general" @import-item="onImport" />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-database ref="database" @save="onSave()" />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-canvas :chart="false" />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-circle />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-title @save="onSave()" />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-legend />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-guideline />
                  </v-tab-item>
                  <v-tab-item :transition="false" :reverse-transition="false">
                    <j-chart-tab-note />
                  </v-tab-item>
                </v-tabs>

                <j-chart-pie
                  v-if="ready2draw"
                  class="canvasAreaLine"
                  ref="chart"
                  :style="`--area-width: ${this.canvas.CanvasWidth + 1}px; --area-height: ${this.canvas.CanvasHeight+ 1}px;`"
                  :ChartType="chartItem.ChartType"
                  :Database="database"
                  :Canvas="canvas"
                  :Title="title"
                  :Circle="circle"
                  :Guideline="guideline"
                  :Legends="legend"
                  :Note="note"
                  :DataItems="chartData"
                  @moved="onMoved"
                  @to-xml-string="onXmlString"
                />

                <div v-if="!isPreviewChart" id="j-chart-table">
                  <div style="display: inline-block;">
                    <j-data-grid
                      hide-actions
                      :headers="previewHeaders"
                      :items="previewItems"
                    >
                      <template #items="props">
                        <tr :active="props.selected">
                          <td>{{ props.item.title }}</td>
                          <td style="text-align: center;">{{ props.item.value }}</td>
                        </tr>
                      </template>
                    </j-data-grid>
                  </div>
                </div>

                <div v-if="helper" id="j-chart-helper">
                  <img :src="helperUrl" />
                </div>

              </div>
            </v-container>
          <!-- </v-form> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <j-alert
      v-model="msgOpen"
      :type="msgInfo.type"
      :title="msgInfo.title"
      :title-description="msgInfo.titleDescription"
      :message="msgInfo.message"
      :button="msgInfo.button"
      :button-text="msgInfo.buttonText"
      @yes="yes()"
      @cancel="msgOpen = false"
    ></j-alert>
  </div>
</template>

<script>
import __C from '@/primitives/_constant_'
import _ChartDataDefault from '@/primitives/_chartPieDefault'
import ChartModalMixin from "@/mixins/chart.modal.common"
import JChartTabProps from './SysenvChartlibPie'

export default {
  name: 'sysenv-chartlib-pie-modal',
  mixins: [
    ChartModalMixin
  ],
  components: {
    ...JChartTabProps
  },
  data: () => ({
    previewHeaders: [
      { type: 'text', text: 'title', value: 'title', sortable: false },
      { type: 'text', text: 'value', value: 'value', sortable: false },
    ],
    idxNum: '',
    subTitle: ''
  }),
  computed: {
    helperUrl() { return this.chartItem.ChartNo && this.helper ? require(`../../../assets/helpDoc/logo.png`) : '' },
    previewItems() { return this.chartData },
    ready2draw() {
      return this.chartItem.ChartType &&
        this.chartData && this.chartData.length > 0 &&
        Object.keys(this.database).length > 0 &&
        Object.keys(this.canvas).length > 0 &&
        Object.keys(this.title).length > 0 &&
        Object.keys(this.circle).length > 0 &&
        Object.keys(this.guideline).length > 0 &&
        Object.keys(this.legend).length > 0 &&
        Object.keys(this.note).length > 0
    }
  },
  watch: {
    // for the default chart-type setting
    chartData: {
      handler(val) {
        if (!val || val.length === 0) return
        // if the chart-type is not selected yet, 
        // set the default chart-type with __C.CHART.TYPE_CODE_NORMAL.
        if (this.modeNew && !this.chartItem['ChartType']) this.onChartType(__C.CHART.TYPE_CODE_NORMAL)
      },
      deep: true
    },
    formOpened(val) {
      if (!val) return

      this.stepper = 0
      // every time came into the modal, either the mode new or edit,
      // whole the store's data should be initialized.
      this.setEmpty()

      if (this.modeNew) {
        this.setChartItem({
          ChartDb: 'Chart',
          CatCode: __C.CHART.CAT_CODE_PIE,
          JsonString: JSON.stringify(_ChartDataDefault.DataItems),

          ..._ChartDataDefault.Database,
          ..._ChartDataDefault.Canvas,
          ..._ChartDataDefault.Circle,
          ..._ChartDataDefault.Title,
          ..._ChartDataDefault.Legends,
          ..._ChartDataDefault.Guideline,
          ..._ChartDataDefault.Note,
          
          QApplied: 'J',
        })
        this.setChartData(_ChartDataDefault.DataItems)
        this.onChartType(__C.CHART.TYPE_CODE_NORMAL)
        this.$refs.general.setData(this.formMode)

      } else {
        this.getChart()
      }
    }
  },
  methods: {
    itemIdx(Idx, chartNo) {
      this.idxNum = `(${Idx} / ${chartNo})`
    },
    itemName(val) {
      this.subTitle = val
    },
    onChartType(typeName) {
      if (!typeName) return

      this.setChartItem({ ChartType: typeName })

      if (typeName == this.__C_.TYPE_CODE_STEPPED) this.setChartItem({
        CircleStackSize: this.circle.CircleStackSize === 0 ? _ChartDataDefault.Circle.CircleStackSize : this.circle.CircleStackSize
      });
      else if (typeName == this.__C_.TYPE_CODE_DONUT) this.setChartItem({
        CircleHoleSize: this.circle.CircleHoleSize === 0 ? _ChartDataDefault.Circle.CircleHoleSize : this.circle.CircleHoleSize,
        CircleStackSize: 0
      });
      else this.setChartItem({
        CircleHoleSize: 0,
        CircleStackSize: 0
      })
    },
    // CRUD Process
    getChart(code=null) {
      return new Promise(resolve => {
        this.chartLibraryService.getChartPie(code || this.keyValue, res => {
          this.setChartItem(res)
          this.setChartData(this.chartItem.QApplied == 'J' ? JSON.parse(this.chartItem.JsonString) : this.chartItem.QResultSummary)

          this.onChartType(this.chartItem.ChartType)
          this.$refs.general.setData(this.formMode)

          this.itemIdx(res.Idx, res.ChartNo)
          this.itemName(res.Name)

          resolve(res)
        })
      })
    },
    putChart(reqItem, callback) {
      this.chartLibraryService.putChartPie(reqItem, callback)
    },
    sasChart(reqItem, callback) {
      this.chartLibraryService.sasChartPie(reqItem, callback)
    },
    updChart(reqItem, callback) {
      this.chartLibraryService.updChartPie(reqItem, callback)
    },
    delChart(chartNo, callback) {
      this.chartLibraryService.delChartPie(chartNo, callback)
    },
  }
}
</script>
